import React, {Component} from 'react';
import {connect} from 'react-redux';
import LangSelector from './LangSelector';

class Footer extends Component {
  render() {
    return (
      <div className="tac max padding ">
        <div className="h-dn">

        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {

  }
}

export default Footer;